import type { OfferStatus } from '@core/offers-types';
import type { Visibility } from '@core/visibility-types';

import type { EmailProviderData } from './email-providers.types';

export enum SharedEmailProviders {
  Google = 'google',
  Microsoft = 'outlook',
  Mailbox = 'mailbox',
}

type OfferAutomatedAction = {
  id: number;
  offer: {
    id: number;
    status: `${OfferStatus}`;
    title: string;
  };
  stage: {
    category: string;
    id: number;
    name: string;
  };
};

type DisqualifyReasonAutomatedAction = {
  id: number;
  disqualifyReason: { id: number; name: string };
};

type Automation = {
  id: number;
  offer?: {
    id: number;
    status: `${OfferStatus}`;
    title: string;
    guid: string;
    slug: string;
  };
  offerTemplate?: {
    id: number;
    title: string;
  };
  disqualifyReason?: {
    id: number;
    name: string;
  };
  pipelineTemplate?: {
    id: number;
    title: string;
    offerId: number;
    offerTemplateId: number;
  };
  stage?: {
    id: number;
    category: string;
    name: number;
  };
};

export type SharedEmailProviderConnectionStatus =
  | 'initial'
  | 'connected'
  | 'error'
  | 'disconnected';

export interface SharedEmailProvider extends EmailProviderData {
  provider: `${SharedEmailProviders}`;
  archivedAt: string | null;
  name: string | null;
  signature: string;
  visibility: Visibility;
  connectUrl?: string;
  connectionStatus: SharedEmailProviderConnectionStatus;
  automatedActions: Array<OfferAutomatedAction & DisqualifyReasonAutomatedAction>;
  automations: Automation[];
}
